import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cfeba1e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "le-health-list-page"
};
const _hoisted_2 = {
  class: "le-health-list-wrap"
};
const _hoisted_3 = {
  key: 0,
  class: "list-content"
};
import LeHealthListItem from './LeHealthListItem.vue';
import { ref, onMounted, getCurrentInstance } from 'vue';
import { leHealthyApi } from '@/api/leHealthList';
import { fullScreen, openLoginPage } from '@/utils/navitiveApi/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'LeHealthList',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const dataList = ref([]);
    const getList = async () => {
      $loading.openLoading();
      try {
        const {
          code,
          message,
          data
        } = await leHealthyApi();
        $loading.closeLoading();
        if (code !== 9000) {
          $alert({
            message
          }).then(() => {
            if (code === 9008) {
              openLoginPage();
            }
          });
          return;
        }
        dataList.value = data.leHealthyList;
        const scroll = window.localStorage.getItem('healthScrollTop');
        if (Number(scroll) > 0) {
          setTimeout(() => {
            var _document$querySelect;
            console.info('赋值scroll', scroll, Number(scroll));
            document.querySelector('.le-health-list-wrap').scrollTop = Number(scroll);
            console.info((_document$querySelect = document.querySelector('.le-health-list-wrap')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollTop);
          }, 50);
        }
      } catch (error) {
        console.error(error);
      }
    };
    onMounted(() => {
      fullScreen();
      getList();
      console.info('乐健康');
      // window.addEventListener('scroll', () => {
      //     const scroll = document.querySelector('.le-health-list-wrap')?.scrollTop || 0
      //     console.info('scrollTop', scroll)
      //     window.localStorage.setItem('healthScrollTop', String(scroll))
      // }, true)
    });

    return (_ctx, _cache) => {
      const _component_nav_bar = _resolveComponent("nav-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
        title: "健康资讯",
        "back-to-close": ""
      }), _createElementVNode("div", _hoisted_2, [dataList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
        return _openBlock(), _createBlock(LeHealthListItem, {
          key: index,
          data: item
        }, null, 8, ["data"]);
      }), 128))])) : _createCommentVNode("", true)])]);
    };
  }
});